/**
 * @file ErrorBoundary
 * @author jiangting01
 */
import * as React from 'react';
import Alert from '.';
export default class ErrorBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            error: undefined,
            info: {
                componentStack: '',
            },
        };
    }
    componentDidCatch(error, info) {
        var _a, _b;
        this.setState({ error, info });
        (_b = (_a = this.props).onError) === null || _b === void 0 ? void 0 : _b.call(_a, error, info);
    }
    render() {
        const { message, description, children } = this.props;
        const { error, info } = this.state;
        if (error) {
            const componentStack = (info === null || info === void 0 ? void 0 : info.componentStack) || null;
            const errorMessage = typeof message === 'undefined' ? (error || '').toString() : message;
            const errorDescription = typeof description === 'undefined' ? componentStack : description;
            return (<Alert type="error" message={errorMessage} description={<pre>{errorDescription}</pre>}/>);
        }
        return children;
    }
}
